"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobilePagination = exports.Pagination = void 0;
var React = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var Dropdown_1 = require("../Dropdown");
var pageSizeOptions = [
    {
        key: 5,
        text: '5 rows',
        value: 5,
    },
    {
        key: 10,
        text: '10 rows',
        value: 10,
    },
    {
        key: 25,
        text: '25 rows',
        value: 25,
    },
    {
        key: 50,
        text: '50 rows',
        value: 50,
    },
    {
        key: 100,
        text: '100 rows',
        value: 100,
    },
];
// todo: exported as default and named export, is there a reason?
var Pagination = function (_a) {
    var page = _a.page, totalPages = _a.totalPages, pageSize = _a.pageSize, onPageChanged = _a.onPageChanged, onPageSizeChanged = _a.onPageSizeChanged, showingText = _a.showingText, _b = _a.siblingRange, siblingRange = _b === void 0 ? 5 : _b, _c = _a.showFirstLast, showFirstLast = _c === void 0 ? false : _c;
    var shouldShowFirstLast = showFirstLast && (totalPages > siblingRange * 2);
    return (React.createElement("div", { style: {
            display: 'flex',
            justifyContent: 'space-between',
        }, className: "pagination" },
        React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            }, className: "pagination__pageSelector" },
            React.createElement(semantic_ui_react_1.Pagination, { activePage: page, totalPages: totalPages, lastItem: shouldShowFirstLast ? totalPages : null, firstItem: shouldShowFirstLast ? 1 : null, siblingRange: siblingRange, onPageChange: onPageChanged })),
        React.createElement("div", { style: {
                display: 'inline-flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '0 1rem',
            }, className: "pagination__dropdownContainer" },
            showingText && showingText(),
            "Display:",
            React.createElement(Dropdown_1.Dropdown, { inline: true, simple: true, size: "small", value: typeof pageSize === 'number' ? pageSize : parseInt(pageSize, 10), options: pageSizeOptions, onChange: function (e, data) { return onPageSizeChanged(data); }, addUndefinedOption: false, className: "pagination__dropdown" }))));
};
exports.Pagination = Pagination;
var MobilePagination = function (_a) {
    var page = _a.page, totalPages = _a.totalPages, pageSize = _a.pageSize, onPageChanged = _a.onPageChanged, onPageSizeChanged = _a.onPageSizeChanged, boundaryRange = _a.boundaryRange, siblingRange = _a.siblingRange, styles = _a.styles, showingText = _a.showingText;
    var styleMap = __assign({ displayDropdown: {}, pagination: {} }, styles);
    return (React.createElement("div", { className: "pagination" },
        React.createElement("div", { style: __assign({ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0 1rem', flexDirection: 'row-reverse' }, styleMap.displayDropdown), className: "pagination__dropdownContainer" },
            React.createElement(Dropdown_1.Dropdown, { inline: true, simple: true, size: "small", value: typeof pageSize === 'number' ? pageSize : parseInt(pageSize, 10), options: pageSizeOptions, onChange: function (_e, data) { return onPageSizeChanged(data); }, addUndefinedOption: false, className: "pagination__dropdown" }),
            "Display:",
            showingText && showingText()),
        React.createElement("div", { className: "pagination__pageSelector" },
            React.createElement(semantic_ui_react_1.Pagination, { activePage: page, totalPages: totalPages, lastItem: null, firstItem: null, siblingRange: siblingRange, onPageChange: onPageChanged, boundaryRange: boundaryRange, style: __assign({ display: 'flex', justifyContent: 'center' }, styleMap.pagination) }))));
};
exports.MobilePagination = MobilePagination;
exports.default = exports.Pagination;
//# sourceMappingURL=index.js.map